
























































































import Vue from "vue";
import { RoomDetail, RoomDisplay } from "@/models/room";
import { RoomDisplayType } from "@/models/room";
import isEqual from "lodash/isEqual";
import VaInfoRow from "@/components/molecules/VaInfoRow.vue";
import VaCard from "@/components/molecules/VaCard.vue";

interface Point2D {
  x: number;
  y: number;
}

// export default (Vue as VueConstructor<Vue>).extend({
export default Vue.extend({
  name: "RoomDisplaysAndroid",
  components: { VaCard, VaInfoRow },
  mounted() {
    this.build();
  },
  data() {
    return {
      displays: [] as Array<RoomDisplay>,
      scaleFactor: 0.12,
      displayType: RoomDisplayType,
      previewHeight: 0,
      previewWidth: 0,
      maxWidth: 0,
      init: false,
      negativeOffset: { x: 0, y: 0 } as Point2D,
      panel: [] as Array<number>,
      screenshots: [],
      processing: false,
      polling: 0,
      lightboxItems: [] as Array<string>,
    };
  },
  methods: {
    displayStyle(display: RoomDisplay): unknown {
      return {
        top: (display.top + this.negativeOffset.y) * this.scaleFactor + "px",
        left: (display.left + this.negativeOffset.x) * this.scaleFactor + "px",
        height: display.height * this.scaleFactor + "px",
        width: display.width * this.scaleFactor + "px",
        backgroundImage: display.preview ? "url(" + display.preview + ")" : "",
      };
    },
    displayLabel(type: number): string {
      switch (type) {
        case this.displayType.MAIN:
          return "PRIMARY";
        case this.displayType.CONSOLE:
          return "CONSOLE";
        case this.displayType.EXTENDED:
          return "EXTENDED";
        default:
          return "";
      }
    },
    build(): void {
      if (!this.room?.displays) return;
      this.displays = this.room.displays;
      this.init = false;
      const points = [] as Array<Point2D>;

      this.displays.forEach((display: RoomDisplay) => {
        if (display.width > this.maxWidth) {
          this.maxWidth = display.width;
        }
        if (display.top < this.negativeOffset.y) {
          this.negativeOffset.y = display.top;
        }
        if (display.left < this.negativeOffset.x) {
          this.negativeOffset.x = display.left;
        }
      });

      this.scaleFactor = this.maxWidth > 3000 ? 0.08 : 0.14;

      this.negativeOffset.x = Math.abs(this.negativeOffset.x);
      this.negativeOffset.y = Math.abs(this.negativeOffset.y);

      this.displays.forEach((display: RoomDisplay) => {
        points.push({
          x: display.left + this.negativeOffset.x,
          y: display.top + this.negativeOffset.y,
        } as Point2D);
        points.push({
          x: display.left + display.width + this.negativeOffset.x,
          y: display.top + this.negativeOffset.y,
        } as Point2D);
        points.push({
          x: display.left + display.width + this.negativeOffset.x,
          y: display.top + display.height + this.negativeOffset.y,
        } as Point2D);
        points.push({
          x: display.left + this.negativeOffset.x,
          y: display.top + display.height + this.negativeOffset.y,
        } as Point2D);
      });

      let max = { x: 0, y: 0 } as Point2D;
      points.forEach((point: Point2D) => {
        if (point.x > max.x) {
          max.x = point.x;
        }
        if (point.y > max.y) {
          max.y = point.y;
        }
      });

      this.previewWidth = max.x * this.scaleFactor;
      this.previewHeight = max.y * this.scaleFactor;
      this.init = true;
    },
  },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
  },
  watch: {
    room: function (current, prev) {
      if (current && !isEqual(current?.displays, prev?.displays)) {
        this.build();
      }
    },
  },
});
